import logoGlow from '../assets/glow_logo.svg';
import lockup from '../assets/hero_lockup.png';
import cardHero from '../assets/card_hero.png';
import boltSm from '../assets/bolt_sm.svg';
import bolt from '../assets/bolt.svg';
import { Bolt, Coin } from './Decor';

/* The Visa card that overlaps the Add Money offer. Rendered on its own when the
   spend section sits above that offer, so the card stays on Add Money. */
export function HeroCard() {
  return (
    <div className="bbd-hero-card">
      <img src={cardHero} alt="" />
    </div>
  );
}

/* Ribbon lockup, headline, light-streak decorations and the hero card art
   (which overlaps the first offer card — the Add Money offer — below it).
   `showCard` hides that art when the Add Money offer isn't being shown. */
export default function Hero({ showCard = true }) {
  return (
    <div className="bbd-hero-head">
      <img className="bbd-logo-glow" src={logoGlow} alt="" />
      <div className="bbd-lockup">
        <img src={lockup} alt="GoSats — The Big Billion Days with Flipkart" />
      </div>

      <h1 className="bbd-title">
        Big deals.
        <br />
        <span className="bbd-grad-text">Bigger rewards.</span>
      </h1>

      <Bolt className="bbd-bolt-hl" src={boltSm} />
      <Coin className="bbd-coin-hl" />
      <Bolt className="bbd-bolt-hr" src={bolt} />
      <Coin className="bbd-coin-hr" />

      {showCard && <HeroCard />}
    </div>
  );
}
